import React from 'react'
import './ContactMeasures.css'

const ContactMeasures: React.FC = () => {
  return (
    <section className="contact-measures" id="contact">
      <div className="measures-container">
        <div className="measures-header">
          <h2 className="measures-title">Let's work together</h2>
          <p className="measures-subtitle">
            Feel free to reach out if you want to collaborate with me, or simply have a chat
          </p>
        </div>

        <div className="contact-info">
          <a href="mailto:omarmdv.dev@gmail.com" className="contact-email">
            omarmdv.dev@gmail.com
          </a>
          <a href="tel:+77066323525" className="contact-phone">
            +7 706 632 35 25 (WP)
          </a>
        </div>
      </div>

      <footer className="social-footer">
        <div className="footer-content">
          <div className="footer-links">
            <a
              href="https://github.com/All1nol"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              GitHub
            </a>
            <a
              href="https://x.com/0marmdv"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Twitter
            </a>
            <a href="#home" className="footer-link">Home</a>
          </div>
          <div className="footer-copyright">
            © 2025 Omarmdv. All rights reserved.
          </div>
        </div>
      </footer>
    </section>
  )
}

export default ContactMeasures